import { options } from "@/global/slick-options";
import { get, getAll } from "@/utilities/querySelector";


getAll('.image-and-content-slider').forEach(section => {
    const images = get('[data-images]', section);
    const contents = get('[data-contents]', section);
    const additionalOptions = JSON.parse(contents?.getAttribute('data-slider-options') ?? '{}');
    
    jQuery(images).slick({
        ...options,
        infinite: true,
        slidesToShow: 1,
        fade: true,
        arrows: false,
        asNavFor: contents,
    });

    jQuery(contents).slick({
        ...options,
        infinite: true,
        fade: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: images,
        ...additionalOptions
    });
});

